import BookedCar from "./icons/BookedCar";
import AssignedCar from "./icons/AssignedCar";
import RequestedCar from "./icons/RequestedCar";
import ReadyCar from "./icons/ReadyCar";
import ReParkedCar from "./icons/ReParkedCar";
import ServiceRequestedCar from "./icons/ServiceRequestedCar";
import ServiceCompletedCar from "./icons/ServiceCompletedCar";

export const BOOKING_STATUSES = {
    DELIVERED: "DELIVERED",
    READY: "READY",
    UPDATED: "UPDATED",
    REMOVED: "REMOVED",
    BOOKED: "BOOKED",
    NOT_BOOKED: "NOT_BOOKED",
    CHECKED_IN: "CHECKED_IN",
    RE_PARKED: "RE_PARKED",
    SERVICE_REQUESTED: "SERVICE_REQUESTED",
    SERVICE_DONE: "SERVICE_DONE",
    ASSIGNED: "ASSIGNED",
    REQUESTED: "REQUESTED"
}

export const BOOKING_STATUSES_UI = (isDark) => ({
    [BOOKING_STATUSES.BOOKED]: {
        content_color: isDark ? '#FFFFFF' : '#3A3A3A',
        background_color: isDark ? '#FFFFFF29' : '#0000000F',
        text: 'Booked',
        icon: BookedCar
    },
    [BOOKING_STATUSES.ASSIGNED]: {
        content_color: isDark ? '#EFC800' : '#EFC800',
        background_color: isDark ? '#EEC80014' : '#EEC80014',
        text: 'Assigned',
        icon: AssignedCar
    },
    [BOOKING_STATUSES.REQUESTED]: {
        content_color: isDark ? '#00AEC5' : '#00AEC5',
        background_color: isDark ? '#00ADC51A' : '#00ADC51A',
        text: 'Requested',
        icon: RequestedCar
    },
    [BOOKING_STATUSES.READY]: {
        content_color: isDark ? '#00B348' : '#00B348',
        background_color: isDark ? '#00B34814' : '#00B34814',
        text: 'Ready',
        icon: ReadyCar
    },
    [BOOKING_STATUSES.RE_PARKED]: {
        content_color: isDark ? '#FFA800' : '#FFA800',
        background_color: isDark ? '#FFBD401A' : '#FFBD401A',
        text: 'Re-Parked',
        icon: ReParkedCar
    },
    [BOOKING_STATUSES.SERVICE_REQUESTED]: {
        content_color: isDark ? '#3A89FF' : '#3A89FF',
        background_color: isDark ? '#3A89FF1A' : '#3A89FF1A',
        text: 'Service Requested',
        icon: ServiceRequestedCar
    },
    [BOOKING_STATUSES.SERVICE_DONE]: {
        content_color: isDark ? '#00C874' : '#00C874',
        background_color: isDark ? '#00C8741A' : '#00C8741A',
        text: 'Service Completed',
        icon: ServiceCompletedCar
    }
})